import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type Store = {
  directDebit: '1' | '0' | null
  setDirectDebit: (value: '1' | '0' | null) => void
  crossSell: '1' | '0' | null
  setCrossSell: (value: '1' | '0' | null) => void
  selectedIBAN: string | null
  setSelectedIBAN: (value: string) => void
  addedIbanList: string[]
  setNewIban: (value: string) => void
}

export const usePaymentStore = create<Store>()(
  devtools(
    (set) => ({
      directDebit: '1',
      setDirectDebit: (directDebit) => set({ directDebit }),
      crossSell: null,
      setCrossSell: (crossSell) => {
        return set((state) => {
          const value = state.crossSell === crossSell ? null : crossSell

          return { crossSell: value }
        })
      },
      selectedIBAN: '',
      setSelectedIBAN: (selectedIBAN) => set({ selectedIBAN }),
      addedIbanList: [],
      setNewIban: (value) =>
        set((state) => {
          if (state.addedIbanList.includes(value)) {
            return { addedIbanList: state.addedIbanList }
          }
          const newData = [...state.addedIbanList, value]

          return { addedIbanList: newData }
        }),
    }),
    { name: 'PaymentStore' },
  ),
)
